<!-- =========================================================================================
    File Name: NotificationsDefault.vue
    Description: Rendering of default notifications
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vx-card title="" code-toggler>
		<vs-row vs-w="12">
			<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
				<div class="demo-alignment">
					<slot></slot>
				</div>
			</vs-col>
		</vs-row>
	</vx-card>
</template>

<script>
export default {
	methods: {
		random() {
			function getRandomInt(min, max) {
				return Math.floor(Math.random() * (max - min)) + min;
			}

			const color = `rgb(${getRandomInt(0, 255)},${getRandomInt(0, 255)},${getRandomInt(0, 255)})`;

			this.$vs.notify({
				title: "Color",
				text: "Lorem ipsum dolor sit amet, consectetur",
				color,
			});
		},
	},
};
</script>
